import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

export function DataConnectSharedClusterTableHeaders() {
  return <>
    <tbody>
      <tr>
        <th className={`${tableHeadersLine} ${noPadddingLeft}` }>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'cluster-name-column-header'} >
            {Messages.dataConnectSiteSettingsClusterColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'cluster-status-column-header'}>
            {Messages.dataConnectSiteSettingsClusterStatusColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine} data-tb-test-id={'shared-cluster-number-of-node-column-header'}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'shared-cluster-number-of-node-column-span'}>
            {Messages.dataConnectSiteSettingsSharedClustersNumberOfNodesColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine} data-tb-test-id={'shared-cluster-empty-column-header'} style={{width: '50%'}}>
          {}
        </th>
      </tr>
    </tbody>
  </>;
}

export const DataConnectTooltipClass = style({
  height: CommonStyles.Sizes.ExtraSmallIconSize,
  marginLeft: TabStyles.Spacing.SmallSpace,
  verticalAlign: 'text-top',
  outlineStyle: 'none'
});

export const tableHeadersLine = style({
  fontSize: 13,
  height: CommonStyles.Sizes.DataGridHeaderHeight,
  borderBottomWidth: CommonStyles.Sizes.LineWidth,
  borderBottomColor: CommonStyles.Colors.DividerLineColor,
  borderBottomStyle: 'solid',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  backgroundColor: CommonStyles.Colors.White,
  borderSpacing: 0,
  paddingLeft: 12,
  paddingRight: 12,
});


export const clusterTableHeadersSmallWidth = style({
  width: '35px'
});

export const noPadddingLeft = style({
  paddingLeft: 0
});

export const textCellPadding = style({
  paddingLeft: 12,
  paddingRight: 12,
});